import capaSepolHost from '../assets/sepol-host.png';
import capaEniato from '../assets/eniato-contailidade.png';
import capaSupere from '../assets/clinica-supere.png';
import capaIfalana from '../assets/ifalana.png';
import capaGrupo55 from '../assets/grupo-55.png';
import capaGrupo55Novo from '../assets/grupo-55-novo.png';
import capaBRL from '../assets/brl-securitizadora.png';
import capaChampion from '../assets/champion.png';
import capaFactura from '../assets/factura.png';
import capaEniatoNovo from '../assets/eniato-novo.png';
import capaBristol from '../assets/bristol-moveis.png';
import capaRaides from '../assets/raides-automotiva.png';
import capaMarino from '../assets/marino-invest.png';

const portfolioProjects = [
  {
    title: 'sepolHOST',
    category: 'Institucional',
    description:
      'Site institucional com cards de produtos e formulário de contato. Desenvolvido em React, vite e php.',
    tags: ['React', 'Planos', 'SEO'],
    url: 'https://sepolhost.com.br/',
    accent: '#E8530A',
    initials: 'AD',
    image: capaSepolHost,
  },
  {
    title: 'Eniato Contabilidade',
    category: 'Institucional',
    description:
      'Site institucional para a Eniato Contabilidade, apresentando a empresa e os serviços contábeis oferecidos, com uma navegação simples que facilita o primeiro contato de quem busca um escritório de confiança.',
    tags: ['React', 'Institucional', 'SEO'],
    url: 'https://eniatocontabilidade.com.br/',
    accent: 'v',
    initials: 'EC',
    image: capaEniato,
  },
    {
    title: 'Eniato Contabilidade',
    category: 'Institucional',
    description:
      'Site institucional para a Eniato Contabilidade reformulado utilizando tecnologias mais novas e modernas, apresentando a empresa e os serviços contábeis oferecidos, com uma navegação simples que facilita o primeiro contato de quem busca um escritório de confiança.',
    tags: ['React', 'Vite', 'SEO'],
    url: 'https://eniatocontabilidade.com.br/site',
    accent: 'v',
    initials: 'EC',
    image: capaEniatoNovo,
  },
  {
    title: 'Clínica Supere',
    category: 'Institucional',
    description:
      'Site institucional da Clínica Supere, especializada em saúde mental e desenvolvimento pessoal, com um visual leve e acolhedor que transmite confiança logo no primeiro contato com o paciente.',
    tags: ['HTML', 'CSS', 'Institucional'],
    url: 'https://clinicasupere.com.br/',
    accent: '#0EA5E9',
    initials: 'IM',
    image: capaSupere,
  },
    {
    title: 'Grupo Factura',
    category: 'Institucional',
    description:
      'Site institucional para o Grupo Factura que atua no mercado oferecendo soluções financeiras para empresas de diversos segmentos.',
    tags: ['React', 'Vite', 'PHP'],
    url: 'https://grupofactura.com.br/',
    accent: '#d1241c',
    initials: 'LP',
    image: capaFactura,
  },
  {
    title: 'Grupo 55',
    category: 'Institucional',
    description:
      'Site institucional da Grupo 55, securitizadora que atua no mercado financeiro, apresentando a empresa e suas operações com clareza e credibilidade para investidores e parceiros.',
    tags: ['WordPress', 'Institucional', 'SEO'],
    url: 'https://grupo55.com.br/site/',
    accent: '#0047B3',
    initials: 'PC',
    image: capaGrupo55,
  },
    {
    title: 'Grupo 55',
    category: 'Institucional',
    description:
      'Site institucional da Grupo 55, totalmente reformulado e utilizando tecnologias novas e atuais de desenvolvimento',
    tags: ['React', 'Vite', 'PHP'],
    url: 'https://grupo55.com.br',
    accent: '#0047B3',
    initials: 'PC',
    image: capaGrupo55Novo,
  },
  {
    title: 'BRL Securitizadora',
    category: 'Institucional',
    description:
      'Site institucional da BRL Securitizadora, apresentando a empresa e suas operações no mercado de securitização com uma comunicação direta e profissional para investidores e parceiros.',
    tags: ['WordPress', 'Institucional', 'SEO'],
    url: 'https://brlsecuritizadora.com.br/site/',
    accent: '#F59E0B',
    initials: 'CO',
    image: capaBRL,
  },
    {
    title: 'Champion Centro Automotivo',
    category: 'Institucional',
    description:
      'Site institucional Champion Centro Automotivo, oficina mecânica geral, pneus e alinhamento, funilaria e pintura.',
    tags: ['HTML', 'JavaScript', 'SEO'],
    url: 'https://championcentroautomotivo.com.br/',
    accent: '#22C55E',
    initials: 'CO',
    image: capaChampion,
  },
    {
    title: 'Baba Ifalana',
    category: 'Institucional',
    description:
      'Site institucional para o terreiro Baba Ifalana, apresentando a casa, sua história e suas atividades religiosas com um visual claro e respeitoso para quem busca conhecer a comunidade.',
    tags: ['HTML', 'CSS', 'Institucional'],
    url: 'https://ifalana.com.br/',
    accent: '#7B3FF2',
    initials: 'LP',
    image: capaIfalana,
  },
      {
    title: 'Bristol Móveis',
    category: 'Institucional',
    description:
      'Desenvolvimento de um site institucional moderno e responsivo para a Bristol Móveis, destacando sua identidade, produtos e serviços, com foco em uma navegação simples e uma experiência digital profissional.',
    tags: ['React', 'Vite', 'Institucional'],
    url: 'https://bristolmoveis.com.br/site',
    accent: '#ba5f0f',
    initials: 'LP',
    image: capaBristol,
  },
        {
    title: 'Raides Automotiva',
    category: 'Institucional',
    description:
      'Desenvolvimento de um site institucional moderno para a Raides Automotiva, destacando os serviços de funilaria e pintura, com foco em credibilidade, qualidade e facilidade de contato.',
    tags: ['React', 'Vite', 'Institucional'],
    url: 'https://raides.com.br',
    accent: '#1f0a45',
    initials: 'LP',
    image: capaRaides,
  },
          {
    title: 'Marino Invest',
    category: 'Institucional',
    description:
      'Desenvolvimento de um site institucional moderno para a Marino Invest, destacando suas soluções em crédito e investimento, com foco em confiança, clareza e facilidade de contato.',
    tags: ['React', 'Vite', 'Institucional'],
    url: 'https://marinoinvest.com.br/site',
    accent: '#1f0a45',
    initials: 'LP',
    image: capaMarino,
  },
];

export default portfolioProjects;